import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import BackToTop from '../components/BackToTop';
import Banner from '../components/Banner';
import ClassificationCard from '../components/ClassificationCard';
import '../css/global.css';
import '../css/ClassificationSocietiesPage.css';

const SOCIETIES = [
  {
    id: 'abs',
    name: 'AMERICAN BUREAU OF SHIPPING',
    logo: '/wp-content/uploads/2025/01/ABS.jpg',
    address: ['Regus Office 1201', 'Level 12, Parkland Building', 'No.33, Park Street', 'Colombo 02.'],
    officeInfo: {
      tel: '+94 11 743 9249',
      mobile: '+94 777 428 642',
      email: 'ABS_Colombo@eagle.org',
      email2: 'SHewawasam@eagle.org',
      web: 'https://www.eagle.org',
      webLabel: 'www.eagle.org',
    },
    person: {
      name: 'Mr. Sriyan S Hewawasam',
      title: 'Senior Surveyor / Authorized Representative',
    },
    reverse: false,
  },
  {
    id: 'bv',
    name: 'BUREAU VERITAS LANKA (PVT) LTD',
    logo: '/wp-content/uploads/2016/02/Bureau-logo.png',
    address: ['7th Floor, JFI Tower 3', 'No. 75, Piyadasa Sirisena Mawatha', 'Colombo 10'],
    officeInfo: {
      tel: '+94 11 473 4325',
      tel2: '+94 11 473 4326',
      fax: '+94 11 462 8629',
      email: 'marine.colombo@bureauveritas.com',
      web: 'https://www.bureauveritas.lk',
      webLabel: 'www.bureauveritas.lk',
    },
    person: {
      name: 'Mr. Achala De Silva',
      title: 'Marine Surveyor / MMS Auditor & MLC Inspector',
      tel: '+94 11 2 44098-50',
      mobile: '+94 70 122 7873',
      mobile2: '+94 77 953 5353',
    },
    reverse: true,
  },
  {
    id: 'dnv',
    name: 'DNV',
    logo: '/wp-content/uploads/2016/02/logo-1.png',
    address: ['Level 37, West Tower, World Trade Center,', 'Colombo 01'],
    officeInfo: {
      tel: '+94 11 749 4260',
      email: 'colombo.maritime@dnv.com',
      web: 'https://www.dnv.com',
      webLabel: 'www.dnv.com',
    },
    person: {
      name: 'Mr. Saman Kumarasinghe',
      title: 'Country Manager',
      mobile: '+94 72 244 0343',
    },
    reverse: false,
  },
  {
    id: 'irs',
    name: 'INDIAN REGISTER OF SHIPPING',
    logo: '/wp-content/uploads/2016/02/logo4.jpg',
    address: ['Level 7, HNB Towers, 479', 'T.B. Jayah Mawatha', 'Colombo 10'],
    officeInfo: {
      tel: '0094 11 267 4885',
      fax: '0094 11 268 7425',
      email: 'colombo@irclass.org',
      web: 'https://www.irclass.org',
      webLabel: 'www.irclass.org',
    },
    person: {
      name: 'Mr. Basab Chakraborty',
      title: 'Country Manager',
      mobile: '+94 773 033 409',
      email: 'basab.chakraborty@irclass.org',
    },
    reverse: true,
  },
  {
    id: 'lr',
    name: 'LLOYDS REGISTER ASIA',
    logo: '/wp-content/uploads/2016/02/logo5.jpg',
    address: ['Level 35 West Tower', 'World Trade Center', 'Colombo 01'],
    officeInfo: {
      tel: '+94 11 257 7077',
      fax: '+94 11 257 4432',
      email: 'colombo@lr.org',
      web: 'https://www.lr.org',
      webLabel: 'www.lr.org',
    },
    person: {
      name: 'Mr. Jagath Kumara',
      title: 'Senior Surveyor In-Charge',
      mobile: '+94 77 340 1235',
      email: 'jagath.kumara@lr.org',
    },
    reverse: false,
  },
  {
    id: 'nk',
    name: 'NIPPON KAIJI KYOKAI (CLASS NK)',
    logo: '/wp-content/uploads/2016/02/logo6.jpg',
    address: ['7 Kothalawala Gardens', 'Colombo 4'],
    officeInfo: {
      tel: '+94 11 259 4455',
      fax: '+94 11 250 8464',
      email: 'classnk.col@classnk.or.jp',
      web: 'https://www.classnk.com',
      webLabel: 'www.classnk.com',
    },
    person: {
      name: 'Mr. Madhawa Fonseka',
      title: 'Manager',
      mobile: '+94 77 727 3245',
      email: 'mfonseka@classnk.or.jp',
    },
    reverse: true,
  },
];

const ClassificationSocietiesPage = () => {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="cs-page">
      <Header />

      <Banner backgroundImage="/wp-content/uploads/2016/02/quality-1.jpg" />

      <section className="contentwrapper clearfix">
        <div className="content clearfix">
          <div className="breadcrumbs">
            <Link to="/" className="home">Home</Link> &gt; <span>Classification Societies</span>
          </div>
          <h1 data-aos="fade-right">Classification Societies</h1>
        </div>
      </section>

      <div className="cs-sections">
        {SOCIETIES.map((s, idx) => (
          <ClassificationCard key={s.id} {...s} index={idx} />
        ))}
      </div>

      <Footer />
      <BackToTop />
    </div>
  );
};

export default ClassificationSocietiesPage;
